import React from 'react';
import { REVIEW_STATUS_LABELS } from '../constants';

const STATUS_STYLES: Record<string, string> = {
  pending_review: 'bg-amber-900/50 text-amber-200 border-amber-700',
  approved: 'bg-green-900/50 text-green-200 border-green-700',
  rejected: 'bg-red-900/50 text-red-200 border-red-800',
  dismissed: 'bg-secondary-700 text-secondary-200 border-secondary-600',
  published: 'bg-primary-900/50 text-primary-200 border-primary-700',
  unpublished: 'bg-secondary-700 text-secondary-200 border-secondary-600',
};

interface ReviewStatusBadgeProps {
  status?: string | null;
}

const ReviewStatusBadge: React.FC<ReviewStatusBadgeProps> = ({ status }) => {
  if (!status) return <span className="text-secondary-500 text-sm">—</span>;
  const key = status.toLowerCase();
  const style = STATUS_STYLES[key] ?? STATUS_STYLES.unpublished;
  const label = REVIEW_STATUS_LABELS[key] ?? status.replace(/_/g, ' ');
  return (
    <span
      className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-medium capitalize ${style}`}
    >
      {label}
    </span>
  );
};

export default ReviewStatusBadge;
